export default __webpack_public_path__ + "static/media/img3.da989125.png";